import { defineComponent as _defineComponent } from 'vue'
import { OnboardingForm } from '@/widgets/Onboarding'

export default /*#__PURE__*/_defineComponent({
  __name: 'CreateOtherProfilePage',
  setup(__props) {


return { __sfc: true,OnboardingForm }
}

})